"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonBadge = void 0;
const React = require("react");
const BronsonBadge = (props) => {
    const renderIcon = () => {
        if (props.icon) {
            return (React.createElement("i", { className: `c-icon  c-icon--[${props.icon}]  c-badge__icon` }));
        }
    };
    return (React.createElement("span", { className: 'c-badge__wrapper ' },
        React.createElement("span", { className: `c-badge  c-badge--${props.status ? props.status : ''}` }, props.children || React.createElement(React.Fragment, null, renderIcon())),
        props.label && (React.createElement("span", { className: 'c-badge__label' }, props.label))));
};
exports.BronsonBadge = BronsonBadge;
